import { useQuery } from "react-query";
import { listClinicDeletionRequests } from "./api";
import ClinicDataDownload from "./ClinicDataDownload";
import ClinicDeletion from "./ClinicDeletion";
import Loader from "src/components/Dashboard/common/Loader";

const ClinicActions = () => {

  const { data, isLoading, isFetching, refetch } = useQuery(["clinic-deletion-requests"], listClinicDeletionRequests);

  // Filter data based on deletionStatus
  const pendingRequests = data?.filter(item =>
    item.deletionStatus?.toLowerCase() === "pending"
  ) || [];

  const approvedRequests = data?.filter(item =>
    item.deletionStatus?.toLowerCase() === "approved"
  ) || [];

  return (
    <div className="d-flex flex-column gap-3 w-100">
      <Loader show={isLoading || isFetching} />
      <ClinicDeletion data={pendingRequests} refetch={refetch} />
      <ClinicDataDownload data={approvedRequests} refetch={refetch} />
    </div>
  );
};

export default ClinicActions;
